/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { Extension, AxiosPost, ResultAPI, AxiosGet } from "service/CommonFunction/TS_function";
import { Grid } from "@mui/material";

import InputFormItem from "components/Common/ElementInForm/InputFormItem";
import DatePickerFormItem from "components/Common/ElementInForm/DatePickerFormItem";
import AutoCompleteSelect from "components/Common/ElementInForm/AutoCompleteSelect";
import Accordion from "components/Common/Accordion/Accordion";
import UploadFile from "components/Common/ElementInForm/UploadFile/UploadFile";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import NativeTimePicker from "components/Common/ElementInForm/NativeTimePicker";
import AsyncAutoComplete from "components/Common/ElementInForm/AsyncAutoComplete";
import InputCustomLabel from "components/Common/ElementInForm/InputCustomLabelFormItem";
import TimePickerFormItem from "components/Common/ElementInForm/TimePickerFormItem";

const VOCFormChat = (props) => {

    const {
        Option,
        arrAttachment,
        setarrAttachment,
        IsOtherVOCService,
    } = props;

    return (
        <>
                <Accordion
                    header="ข้อมูลข้อร้องเรียน"
                    props={{ sx: { width: "100%" } }}
                >
                    <Grid item xs={12}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" className='Input-Disabled'>
                            <Grid item xs={12}>
                                <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="start" >
                                    <Grid item xs={12} sm={3}>
                                        <InputFormItem
                                            id="sJobCode"
                                            name="sJobCode"
                                            label="เลขที่ใบงาน"
                                            required={false}
                                            fullWidth
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <InputFormItem
                                            id="sVOCFormCode"
                                            name="sVOCFormCode"
                                            label="เลขที่ใบแจ้ง"
                                            required={false}
                                            fullWidth
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <AsyncAutoComplete
                                    name="oCustomer"
                                    sUrlAPI={"User/SearchUser"}
                                    label="ลูกค้า"
                                    required={true}
                                    sMethodAxios={"POST"}
                                    disabled={true}
                                    textSearch={"กรอกชื่อลูกค้า/นามสกุลลูกค้า"}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <AutoCompleteSelect
                                    name="oBA"
                                    options={[]}
                                    label={"กลุ่มตลาด"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AutoCompleteSelect
                                    name="oCompany"
                                    options={[]}
                                    label={"บริษัท"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AutoCompleteSelect
                                    name="oAddress"
                                    options={[]}
                                    label={"ที่อยู่/สถานที่เกิดเหตุ"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <AutoCompleteSelect
                                    name="oVOCType"
                                    options={[]}
                                    label={"ประเภท"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <AutoCompleteSelect
                                    name="oVOCService"
                                    options={[]}
                                    label={"บริการที่ต้องการ / ปัญหาที่พบ"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            {IsOtherVOCService ?
                                <Grid item xs={12} >
                                    <InputFormItem
                                        id="sOtherVOCService"
                                        name="sOtherVOCService"
                                        label="บริการที่ต้องการ / ปัญหาที่พบ (อื่นๆ)"
                                        required={true}
                                        fullWidth
                                        disabled={true}
                                    />
                                </Grid>
                                : null
                            }
                            <Grid item md={12} xs={12}>
                                <InputCustomLabel
                                    id="sDetail"
                                    name="sDetail"
                                    label="รายละเอียด"
                                    required={true}
                                    multiline={true}
                                    maxLength={1000}
                                    rows={4}
                                    fullWidth
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <AutoCompleteSelect
                                    name="oTel"
                                    options={[]}
                                    label={"หมายเลขโทรศัพท์"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <AutoCompleteSelect
                                    name="oNoticeChannel"
                                    options={[]}
                                    label={"ช่องทางที่รับแจ้ง"}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                    <Grid item xs={12} sm={6} md={5}>
                                        <DatePickerFormItem
                                            name="sDateIssue"
                                            label="วันที่แจ้ง"
                                            fullWidth={true}
                                            required={true}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <TimePickerFormItem
                                            name="sTimeIssue"
                                            label="เวลาที่แจ้ง"
                                            fullWidth={true}
                                            required={true}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6} style={{ marginTop: '-8px',display: arrAttachment.length == 0 ? "none" : "" }}>
                                <UploadFile
                                    id="sDocFile"
                                    keyID={1}
                                    sTitle={"เอกสารแนบ"}
                                    IsRequired={true}
                                    arrFile={arrAttachment || []}
                                    setarrFile={setarrAttachment}
                                    IsFolder={false}
                                    IsFile={true}
                                    IsMultiple={false}
                                    Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                    IsDrag={false}
                                    nLimitFile={10}
                                    sLimitFile={"MB"}
                                    disabled={true}
                                    IsHiddenUploadBox={true}

                                // onClearFile={onClearFile}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Accordion>
        </>
    );
}
export default VOCFormChat